import React from 'react'
import { View, Image, Text } from 'react-native'
import styles from './StatusTagsStoresStyles'
import { Feather } from '@expo/vector-icons'
import theme from '../../../theme'
import { getLanguage } from '../appBar/context/LocalizationContext'
import { STORE_STATUS } from './constants/constants.stores'

export class CampaignStatus {
    static readonly STATUS_FORM_PENDING = 0
    static readonly STATUS_FORM_APPROVED = 1
    static readonly STATUS_FORM_PENDING_MODERATION = 2
    static readonly STATUS_FORM_REFUSED = 3
    static readonly STATUS_FORM_IN_PROGRESS = 4
    static readonly STATUS_FORM_PENDING_SYNC = 5
    static readonly STATUS_FORM_IN_PROGRESS_BY_OTHER = 7
    static readonly STATUS_MODERATION_APPROVED = 8
}
export const getStatusMap = (languageFile) => ({
    [CampaignStatus.STATUS_FORM_PENDING]: {
        label: languageFile.pending_mayus,
        color_hex: theme.colors.colorPending,
    },
    [CampaignStatus.STATUS_FORM_APPROVED]: {
        label: languageFile.visited_mayus,
        color_hex: theme.colors.colorApproved,
    },
    [CampaignStatus.STATUS_MODERATION_APPROVED]: {
        label: 'APROBADO',
        color_hex: theme.colors.colorApproved,
    },
    [CampaignStatus.STATUS_FORM_PENDING_MODERATION]: {
        label: 'EN REVISIÓN',
        color_hex: theme.colors.mediumGray,
    },
    [CampaignStatus.STATUS_FORM_REFUSED]: {
        label: languageFile.review_mayus,
        color_hex: theme.colors.error,
    },
    [CampaignStatus.STATUS_FORM_IN_PROGRESS]: {
        label: languageFile.in_progress_mayus,
        color_hex: theme.colors.colorTertiary,
    },
    [CampaignStatus.STATUS_FORM_PENDING_SYNC]: {
        label: languageFile.visited_mayus,
        color_hex: theme.colors.alert,
    },
    [CampaignStatus.STATUS_FORM_IN_PROGRESS_BY_OTHER]: {
        label: 'OCUPADO',
        color_hex: theme.colors.mediumGray,
    },
    [STORE_STATUS.INCIDENCE_REPORTED_CLOSE]: {
        label: 'CERRADO',
        color_hex: 'black',
    },
    [STORE_STATUS.INCIDENCE_REPORTED]: { label: 'INCIDENCIA', color_hex: 'red' },
    [STORE_STATUS.INCIDENCE_REPORTED_PERMANENTE]: {
        label: 'INCIDENCIA',
        color_hex: 'red',
    },
})
export const StatusTagsStores = ({ status }: { status: number }) => {
    const { languageFile } = getLanguage()

    switch (status) {
        case CampaignStatus.STATUS_FORM_PENDING:
            return (
                <>
                    <View
                        style={[
                            styles.statusModuleList,
                            { backgroundColor: theme.colors.colorPending },
                        ]}
                    >
                        <Feather
                            style={styles.paddingRight}
                            name='circle'
                            size={16}
                            color={'white'}
                        />
                        <Text style={[styles.statusModuleText, { color: 'white' }]}>
                            {languageFile.pending_mayus}
                        </Text>
                    </View>
                </>
            )
        case CampaignStatus.STATUS_FORM_APPROVED:
            return (
                <>
                    <View
                        style={[
                            styles.statusModuleList,
                            { backgroundColor: theme.colors.colorApproved },
                        ]}
                    >
                        <Feather
                            style={styles.paddingRight}
                            name='check'
                            size={16}
                            color='white'
                        />
                        <Text style={[styles.statusModuleText, { color: 'white' }]}>
                            {languageFile.visited_mayus}
                        </Text>
                    </View>
                </>
            )
        case CampaignStatus.STATUS_MODERATION_APPROVED:
            return (
                <>
                    <View
                        style={[
                            styles.statusModuleList,
                            { backgroundColor: theme.colors.colorApproved },
                        ]}
                    >
                        <Feather
                            style={styles.paddingRight}
                            name='check'
                            size={16}
                            color='white'
                        />
                        <Text style={[styles.statusModuleText, { color: 'white' }]}>
                            APROBADO
                        </Text>
                    </View>
                </>
            )
        case CampaignStatus.STATUS_FORM_PENDING_MODERATION:
            return (
                <>
                    <View
                        style={[
                            styles.statusModuleList,
                            {
                                backgroundColor: 'transparent',
                                borderColor: theme.colors.mediumGray,
                                borderWidth: 2.0,
                            },
                        ]}
                    >
                        <Feather
                            style={styles.paddingRight}
                            name='user'
                            size={16}
                            color={theme.colors.mediumGray}
                        />
                        <Text
                            style={[
                                styles.statusModuleText,
                                { color: theme.colors.mediumGray },
                            ]}
                        >
                            EN REVISIÓN
                        </Text>
                    </View>
                </>
            )
        case CampaignStatus.STATUS_FORM_REFUSED:
            return (
                <>
                    <View
                        style={[
                            styles.statusModuleList,
                            { backgroundColor: theme.colors.error },
                        ]}
                    >
                        <Feather
                            style={styles.paddingRight}
                            name='alert-triangle'
                            size={16}
                            color='white'
                        />
                        <Text style={[styles.statusModuleText, { color: 'white' }]}>
                            {languageFile.review_mayus}
                        </Text>
                    </View>
                </>
            )
        case CampaignStatus.STATUS_FORM_IN_PROGRESS:
            return (
                <>
                    <View
                        style={[
                            styles.statusModuleList,
                            { backgroundColor: theme.colors.colorSecondary },
                        ]}
                    >
                        <Feather
                            style={styles.paddingRight}
                            name='loader'
                            size={16}
                            color='white'
                        />
                        <Text style={[styles.statusModuleText, { color: 'white' }]}>
                            {languageFile.in_progress_mayus}
                        </Text>
                    </View>
                </>
            )
        case CampaignStatus.STATUS_FORM_PENDING_SYNC:
            return (
                <>
                    <View
                        style={[
                            styles.statusModuleList,
                            { backgroundColor: theme.colors.alert },
                        ]}
                    >
                        <Feather
                            style={styles.paddingRight}
                            name='clock'
                            size={16}
                            color={theme.colors.textPrimary}
                        />
                        <Text
                            style={[
                                styles.statusModuleText,
                                { color: theme.colors.textPrimary },
                            ]}
                        >
                            {languageFile.visited_mayus}
                        </Text>
                    </View>
                </>
            )
        case CampaignStatus.STATUS_FORM_IN_PROGRESS_BY_OTHER:
            return (
                <>
                    <View
                        style={[
                            styles.statusModuleList,
                            { backgroundColor: theme.colors.colorPending },
                        ]}
                    >
                        <Feather
                            style={styles.paddingRight}
                            name='circle'
                            size={16}
                            color={'white'}
                        />
                        <Text style={[styles.statusModuleText, { color: 'white' }]}>
                            OCUPADO
                        </Text>
                    </View>
                </>
            )
        case STORE_STATUS.INCIDENCE_REPORTED_PERMANENTE:
        case STORE_STATUS.INCIDENCE_REPORTED:
            return (
                <>
                    <View
                        style={[styles.statusModuleList, { backgroundColor: 'red' }]}
                    >
                        <Feather
                            style={styles.paddingRight}
                            name='circle'
                            size={16}
                            color={'white'}
                        />
                        <Text style={[styles.statusModuleText, { color: 'white' }]}>
                            INCIDENCIA
                        </Text>
                    </View>
                </>
            )

        case STORE_STATUS.INCIDENCE_REPORTED_CLOSE:
            return (
                <>
                    <View
                        style={[
                            styles.statusModuleList,
                            { backgroundColor: 'black' },
                        ]}
                    >
                        <Feather
                            style={styles.paddingRight}
                            name='circle'
                            size={16}
                            color={'white'}
                        />
                        <Text style={[styles.statusModuleText, { color: 'white' }]}>
                            CERRADO
                        </Text>
                    </View>
                </>
            )

        default:
            return null
    }
}

export const StatusTagItem = ({
    status,
    title,
    color,
}: {
    status: number
    title: string
    color: string
}) => {
    return (
        <>
            <View
                style={[
                    styles.statusModuleList,
                    { backgroundColor: color || theme.colors.colorPending },
                ]}
            >
                <Feather
                    style={styles.paddingRight}
                    name='check'
                    size={16}
                    color='white'
                />
                <Feather
                    style={styles.paddingRight}
                    name='circle'
                    size={16}
                    color='white'
                />
                <Feather
                    style={styles.paddingRight}
                    name='alert-triangle'
                    size={16}
                    color='white'
                />
                <Text style={[styles.statusModuleText, { color: 'white' }]}>
                    {title.toUpperCase()}
                </Text>
            </View>
        </>
    )
}
;<View
    style={{
        borderWidth: 1,
        borderRadius: 15,
        borderColor: theme.colors.colorPrimary,
    }}
>
    <Image
        style={[styles.statusImage, { tintColor: theme.colors.colorPrimary }]}
        source={require('../../../assets/stores/store.png')}
    />
</View>
